<ion-content>
  <app-surveys></app-surveys>
</ion-content>
